import { Directive } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS } from '@angular/forms';

export function ValidateConfermaMail(control: AbstractControl): {[key: string]: any} | null  {
    
    if (control.parent && (control.parent.get('email').value !== control.parent.get('confermaemail').value)) {
        return { confmailnotvalid: true };
    }
    
    return null; // return null if validation is passed.
}

@Directive({
  selector: '[appConfermaMailValidatorDirective]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: AppConfermaMailValidatorDirective,
    multi: true
  }]
})
export class AppConfermaMailValidatorDirective implements Validator {
  validate(control: AbstractControl) : {[key: string]: any} | null {
    return ValidateConfermaMail(control);
  }
}